import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Row, Col, Table, Card, CardBody } from "reactstrap";
import CardItem from "./CardItem";
import { adminPrefix } from "configs/routePrefix";
import Paginator from "components/Common/Paginator/Paginator";
import ResaleService from "services/Admin/ResaleService";
import StatusModal from "./StatusModal";
import FilterIcon from "assets/images/filter.png";
import FilterModal from "./FilterModal";
import { useSelector } from "react-redux";

const ResalePage = (props) => {
	const resaleService = new ResaleService();
	const [active, setActive] = useState("all");
	const [searchWord, setSearchWord] = useState("");
	const [list, setList] = useState([]);
	const [modal, setModal] = useState(false);
	const [statusmodal, setStatusModal] = useState(false);
	const [editResale, setEditResale] = useState(null);
	const [location, setLocation] = useState("");
	const [filtersParams, setFilterParams] = useState(null);
	const [filterData, setFilterData] = useState({
		area_ids: "",
		country: "",
	});
	const [shouldGetData, setShouldGetData] = useState(false);
	const AuthData = useSelector((state) => state.Auth);
	const isExist = (data) =>
		AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com";
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});

	const addHandler = () => {
		props.history.push(`${adminPrefix}/resale/create-resale`);
	};
	const updateHandler = (id) => {
		props.history.push(`${adminPrefix}/resale/edit-resale/${id}`);
	};
	const viewHandler = (id) => {
		props.history.push(`${adminPrefix}/resale/view-resale/${id}`);
	};

	const OnSearchChange = (e) => {
		const search = e.target.value;
		setSearchWord(search);
	};
	useEffect(() => {
		// debounce solution to reduce request data from api
		const timeoutId = setTimeout(() => {
			const params = {};
			if (active != "all") params["status"] = active;
			if (searchWord.trim().length) params["keyword"] = searchWord;
			if (filterData.area_ids?.length)
				params["area_ids"] = filterData.area_ids
					?.map((item) => item.value)
					.join();
			// if (!!filterData.country) params["country"] = filterData.country?.value
			setFilterParams({ ...params });
		}, 100);

		return () => clearTimeout(timeoutId);
	}, [active, searchWord, filterData]);

	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>Resale</title>
				</MetaTags>
				<Container fluid>
					<Row className="mb-1">
						<Col md={6}>
							<h4>Manage Resales</h4>
							<p>You can manage All Resales with diffrent status</p>
						</Col>
					</Row>
					<Row>
						<Col md={6}>
							<div className="form-group has-search">
								<span className="fa fa-search form-control-feedback"></span>
								<input
									type="text"
									className="form-control"
									placeholder="Search by resale name, I.D"
									onChange={(e) => OnSearchChange(e)}
									value={searchWord}
								/>
							</div>
						</Col>
						{isExist("resale.add") ? (
							<Col md={6}>
								<div className="d-md-flex justify-content-md-end mb-2">
									<button
										className="btn btn-success btnHeight px-lg-4"
										onClick={addHandler}>
										Add New Resale
									</button>
								</div>
							</Col>
						) : null}
					</Row>
					<Row className="my-4">
						<Col sm={8} className="mb-3">
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "all" ? "#556ee6" : "#f4f4f4",
									color: active == "all" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("all");
								}}>
								All
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "Live" ? "#556ee6" : "#f4f4f4",
									color: active == "Live" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("Live");
								}}>
								Live
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "Rejected" ? "#556ee6" : "#f4f4f4",
									color: active == "Rejected" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("Rejected");
								}}>
								Rejected
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "Pending" ? "#556ee6" : "#f4f4f4",
									color: active == "Pending" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("Pending");
								}}>
								Pending
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "Sold" ? "#556ee6" : "#f4f4f4",
									color: active == "Sold" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("Sold");
								}}>
								Sold
							</button>
							<button
								className="btn btnHeight me-2 px-4"
								style={{
									background: active == "Not_Available" ? "#556ee6" : "#f4f4f4",
									color: active == "Not_Available" ? "#FFF" : "#495057",
								}}
								onClick={() => {
									setActive("Not_Available");
								}}>
								Not Available
							</button>
						</Col>
						<Col sm={4} className="mb-3 d-flex flex-row-reverse">
							<button
								className="btn btnUpload btnHeight px-4"
								style={{ margin: "0" }}
								onClick={() => {
									setModal(!modal);
								}}>
								{" "}
								<img src={FilterIcon} style={{ marginRight: "5px" }} /> Filter
							</button>
						</Col>
					</Row>
					<div>
						<Card className="w-100 mt-4">
							<CardBody>
								<div className="py-3">
									<div>
										<div className="table-responsive">
											<Table>
												<thead>
													<tr className="bgHeaderTable">
														<th className="font-size-14">I.D</th>
														<th className="font-size-14">Seller Name</th>
														<th className="font-size-14">Unit Type</th>
														<th className="font-size-14">Rooms No</th>
														<th className="font-size-14">Floor No</th>
														<th className="font-size-14">Location</th>
														<th className="font-size-14">Compound</th>
														<th className="font-size-14">Sales Rep</th>
														<th className="font-size-14">Last Updated</th>
														<th className="font-size-14">Status</th>
														<th className="font-size-14"></th>
													</tr>
												</thead>
												<tbody>
													{list.map((item, index) => {
														return (
															<CardItem
																key={index}
																index={index}
																{...item}
																item={item}
																Service={ResaleService}
																updateHandler={() => updateHandler(item.id)}
																viewHandler={() => viewHandler(item.id)}
																setStatusModal={setStatusModal}
																setEditResale={() => setEditResale(item)}
																setShouldGetData={setShouldGetData}
															/>
														);
													})}
												</tbody>
											</Table>
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
						<Row className="d-flex justify-content-end">
							<Col className="d-flex justify-content-between" md={12} sm={12}>
								<Paginator
									service={resaleService}
									pageOptions={pageOptions}
									setData={(data) => setList([...data])}
									setPageOptions={setPageOptions}
									filtersParams={filtersParams}
									shouldGetData={shouldGetData}
									setShouldGetData={setShouldGetData}
								/>
							</Col>
						</Row>
					</div>
					{modal ? (
						<FilterModal
							filterModal={modal}
							setFilterModal={() => setModal(!modal)}
							updateFiltersData={setFilterData}
							filtersData={filterData}
						/>
					) : null}
					{statusmodal ? (
						<StatusModal
							modal={statusmodal}
							setShouldGetData={setShouldGetData}
							toggle={() => {
								setStatusModal(!StatusModal);
								setEditResale(null);
							}}
							editResale={editResale}
						/>
					) : null}
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ResalePage;
